import(/* webpackMode: "eager" */ "/codebuild/output/src584700147/src/src/app/global-error.tsx");
